import WeekSlides from './WeekSlides'

export default class {
  constructor() {

    const domWeekSlides = document.querySelector('[data-js="week-slide"]');
    if (domWeekSlides) new WeekSlides(domWeekSlides);
  }
}
